<template>
    <div class="one-info-show">
        <div
            class="information flex_wrap"
            v-for="(list,index) in data"
            :key="index"
        >
            <div class="information-content" :class="item.splitLine ? 'split-line' : ''" v-for="(item, index) in list" :key="index">
                <div class="infor-title" v-if="item.title">{{item.title}} <span v-if="item.event" @click="titleClick(item.event)" v-text="item.subTitle"></span></div>
                <div class="infors">
                    <div class="infirss" :style="{'min-width': (subItem.minWidth || '280px')}" v-for="(subItem, subIndex) in item.subItems" :key="subIndex">
                        <div class="infor" v-if="!subItem.noShow">
                            <span class="label" :style="{ 'width':(subItem.labelWidth || '80px')}">{{subItem.label}}</span>：
                              <span class="value" v-if="subItem.dblclick" :class="subItem.class" :title="subItem.value" @dblclick="dblclick(subItem.value)">
                                {{subItem.value?subItem.value:''}}
                                <span
                                    class="message"
                                    v-for="(item,index) in subItem.message"
                                    :key="index"
                                >
                                    <span v-if="item.value" class="icon" :style="'background-image:url('+item.icon+')'"></span>
                                    {{item.value}}
                                </span>
                                <span class="images" @click='openMapClick' :style="'background-image:url('+subItem.images.url+')'" v-if="subItem.images"></span>
                            </span>
                            <span class="value" v-else :class="subItem.class" :title="subItem.value">
                                {{subItem.value?subItem.value:''}}
                                <span
                                    class="message"
                                    v-for="(item,index) in subItem.message"
                                    :key="index"
                                >
                                    <span v-if="item.value" class="icon" :style="'background-image:url('+item.icon+')'"></span>
                                    {{item.value}}
                                </span>
                                <span class="images" @click='openMapClick' :style="'background-image:url('+subItem.images.url+')'" v-if="subItem.images"></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="signBox pos_a">
            <div class="circular" v-if="showLog" @click="operation">log</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        infoData: {
            type: Array
        },
        showLog: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            data: [],
            color: ['#F56C6C', '#00bcbf', '#409EFF', '#E6A23C', '#67C23A']
        };
    },
    watch: {
        infoData() {
            this.showList();
        }
    },
    methods: {
        dblclick(clickContent) {
            if (clickContent && clickContent !== 'undefined') {
                var input = document.createElement('input');
                document.body.appendChild(input);
                input.setAttribute('value', clickContent);
                input.setAttribute('readonly', 'readonly');
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                this.$message.success(`‘${input.value}’复制成功`);
            }
        },
        operation() {
            this.$emit('operation', '');
        },
        showAccessory() {
            this.$emit('showAccessory', '');
        },
        openMapClick() {
            this.$emit('openMapClick', '');
        },
        showList() {
            let arr = [];
            const data = [];
            this.infoData.map((item, index) => {
                if (!item.showItem) {
                    arr.push(item);
                }
                if ((arr.length) % 3 === 0 || index === this.infoData.length - 1) {
                    data.push(arr);
                    if (index === this.infoData.length - 1) {
                        if (arr.length % 3 === 0) {
                            return;
                        } else {
                            arr.width = '48%';
                        }
                    }
                    arr = [];
                }
            });
            this.data = data;
        },
        titleClick(event) {
            this.$emit(event);
        }
    },
    mounted() {
        this.showList();
    }
};
</script>

<style lang="less" >
.one-info-show {
    position: relative;
    .information-content {
        box-sizing: border-box;
        padding-left: 12px;
        .infor-title {
            font-size: 15px;
            line-height: 30px;
            color: #66625a;
        }
        .el-collapse-item__content{
            padding-bottom: 0px;
        }
        .infors{
            display: flex;
            justify-content: flex-start;
            line-height: 24px;
            .infirss{
                min-width: 280px;
            }
            .infor {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                .value {
                    color: #333;
                    font-size: 12px;
                }
        }
        }
    }
    .label {
        display: inline-block;
        text-align: right;
        font-size: 12px;
        color: #999;
    }
    .split-line {
        border-top: 1px solid #ccc;
    }
    .message:not(:last-child) {
        margin-right: 32px;
        height: 12px;
    }
    .icon {
        display: inline-block;
        width: 12px;
        height: 12px;
        background-size:contain;
        background-position: center;
        background-repeat: no-repeat;
    }
    .images {
        display: inline-block;
        width: 14px;
        height: 14px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        margin-left: 32px;
        cursor: pointer;
    }
    .pos_a {
        position: absolute;
    }
    .signBox{
        width:28px;
        box-sizing: border-box;
        top:12px;
        right: 24px;
    }
    .circular {
        cursor: pointer;
        text-align: center;
        width: 28px;
        height: 28px;
        line-height: 28px;
        background: #00bcbf;
        color: #fff;
        border-radius: 50%;
        font-size: 12px;
    }
}
</style>